export default __webpack_public_path__ + "static/media/quickstart2-1.55c50a51.svg";